import { render, staticRenderFns } from "./UserAddForm.vue?vue&type=template&id=12f46ee2"
import script from "./UserAddForm.vue?vue&type=script&lang=js"
export * from "./UserAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f46ee2')) {
      api.createRecord('12f46ee2', component.options)
    } else {
      api.reload('12f46ee2', component.options)
    }
    module.hot.accept("./UserAddForm.vue?vue&type=template&id=12f46ee2", function () {
      api.rerender('12f46ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsTeam/UserAddForm.vue"
export default component.exports